






















import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { TicketStatusMap } from "@/data/enums/tickets";

// Types
import { IStatus } from "@/models/statuses";

@Component
export default class TicketStatusDropdown extends Vue {
  // Props

  @Prop({ default: false })
  public isStaged!: boolean;

  @Prop({ default: () => [] })
  public ticketStatuses!: IStatus[];

  @Prop({ default: () => [] })
  public statusId!: IStatus["id"];

  @Prop({ default: false })
  public isProcessing!: boolean;

  @Prop({ default: "is-bottom-left" })
  public position!: string;

  // Computed

  public get statusMap() {
    return TicketStatusMap();
  }
}
